import { Box, List, ListItem, Typography } from "@mui/material";
import { DocumentHyperlink } from '../../components/DocumentHyperlink';
import { listContainerStyle, listItemStyle, titleStyle } from './styled';
import { HumanResourcesForms } from "./DownlodableFormsModel";

export type DownloadableFormItem = {
  text: string;
  path: string;
}

export type DownloadableFormsProps = {
  list: DownloadableFormItem[];
  title: string;
}

export const DownloadableForms = ({ list, title }: DownloadableFormsProps) => {
  const handleDownload = (path: string) => window.open(path);
  return (
    <Box sx={listContainerStyle}>
      <Typography sx={titleStyle} data-automation="section-header">{title}</Typography>
      <List sx={{ padding: 0 }}>
        {list.map(({ text, path }) => (
          <ListItem sx={listItemStyle} key={text}>
            <DocumentHyperlink title={text} onClick={() => handleDownload(path)} dataAutomation='form-link' />
          </ListItem>
        ))}
      </List>
      {list === HumanResourcesForms &&
        <Typography sx={{py: 3}}>
          <Typography component={'span'} sx={{ pr: '5px' }}>For information on your benefit coverage and forms, visit</Typography> 
          <Box sx={{ display: 'inline-flex', pr: '5px' }}>
            <DocumentHyperlink
              link='https://www.longshoreplans.ca'
              title='longshoreplans.ca'
              target='_blank'
              icon={null}
              dataAutomation='longshore-plan-link'
            />
          </Box>
          <Typography component={'span'} sx={{ pr: '5px' }}>or contact the Waterfront Employers Benefit Office at</Typography>
          <Box sx={{ display: 'inline-flex' }}>
            <DocumentHyperlink
              link='tel:+16046897184'
              title='604-689-7184'
              target='_self'
              icon={null}
              dataAutomation='telephone-link'
            />
          </Box>
          .
        </Typography>
      }
    </Box>
  )
} 